import { ProductType, SubscriptionStatus } from 'src/services/billing/billing.types';
import { PaymentCollectionType } from 'src/services/organisation/organisation.types';

import { Organization } from '../auth/auth.types';
import { CandidateProfile } from '../candidates/candidates.types';
import { ICompanyProfile } from '../connections/connections.types';

export type AdminOrganization = {
  company_profile?: ICompanyProfile;
  candidate_profile?: CandidateProfile;
  subscriptions?: { id: string, status: SubscriptionStatus, type: ProductType }[];
} & Organization;

export interface RestrictedOrganizationSettings {
  payment_collection_type?: PaymentCollectionType;
  invoice_due_days?: number;
}

// ---- gated agency/employer onboarding ----

export enum ActivationOrigin {
  SELF_SERVICE = 'self_service',
  ADMIN_CREATED = 'admin_created',
}

export enum ActivationRequestStatus {
  PENDING_REVIEW = 'pending_review',
  LINK_SENT = 'link_sent',
  COMPLETED = 'completed',
  DECLINED = 'declined',
}

export interface ActivationRequest {
  id: string;
  organization_id: string;
  origin: ActivationOrigin;
  status: ActivationRequestStatus;
  /** The applicant's free text answer to how many seats they need. */
  requested_seats: string | null;
  company_name: string | null;
  tax_id: string | null;
  contact_name: string;
  contact_email: string;
  contact_phone: string | null;
  product_identifier: string | null;
  billing_period: string | null;
  seats: number | null;
  promo_code: string | null;
  activation_url: string | null;
  expires_at: string | null;
  first_opened_at: string | null;
  approved_at: string | null;
  completed_at: string | null;
  created_at: string;
}

/** Commercial terms a super admin agrees before issuing the activation link. */
export interface ActivationTerms {
  product_identifier: string;
  billing_period: string;
  seats: number;
  promo_code?: string;
  expires_in_days?: number;
}

export interface ActivateTenantPayload {
  product_identifier?: string;
  billing_period?: string;
  seats?: number;
}

export type CreateTenantPayload = ActivationTerms & {
  tenant_type: string;
  company_name: string;
  tax_id: string;
  country_code: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  phone_country_code?: string;
  timezone?: string;
};

// ---- tenant purge ----

export interface PurgePreview {
  organization_id: string;
  company_name: string | null;
  tenant_type: string;
  status: string;
  users_to_delete: number;
  users_retained: number;
  total_rows: number;
  tables: Record<string, number>;
  /** Reasons the purge is refused. Empty means it can proceed. */
  blockers: string[];
}